var __importDefault = (this && this.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};
import { keyframes } from '@fluentui/react';
const shimmerAnimation = keyframes({
    '0%': { backgroundPosition: '-1000px 0' },
    '100%': { backgroundPosition: '1000px 0' },
});
export const cellStyle = () => ({
    root: {
        display: 'flex',
        justifyContent: 'space-between',
        border: 'none',
        selectors: {
            '.cell-div': {
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '60px',
                width: '60px',
            },
            '.cell-input': {
                border: 'none',
                outline: 'none',
                textAlign: 'center',
                width: '30px',
                height: '30px',
                fontWeight: 600,
            },
            '.cell-glimmer': {
                color: '#4177CF',
                fontSize: '15px',
            },
        },
    },
});
//# sourceMappingURL=GridCellComponent.styles.js.map